import { enable } from '@wix/ambassador-studio-v1-workspace/http'
import { retry } from '@wix/funnel-utils'

import { withMonitoring } from '../../../monitoring/withMonitoring'
import { ambassadorHttpClient } from '../../httpClient'
import { isUserNewlyRegistered } from './isUserNewlyRegistered'

export const markAsWixStudioAccount = async () => {
  const isNewlyRegistered = await isUserNewlyRegistered()
  const revertible = isNewlyRegistered === null ? true : !isNewlyRegistered

  const fn = () => ambassadorHttpClient.request(enable({ revertible }))
  const fnWithRetry = () => retry(fn)

  await withMonitoring(fnWithRetry, 'markAsWixStudioAccount')
}
